import { useMsal } from "@azure/msal-react";

export default function useUserEmail() {
  const { instance } = useMsal();
  const isMockAuth = process.env.REACT_APP_MOCK_AUTH === "true";
  const email = isMockAuth
    ? process.env.REACT_APP_TEST_EMAIL
    : instance.getAllAccounts()[0]?.username || "";
  return String(email || "").trim().toLowerCase();
}